module.exports = __webpack_public_path__ + "img/head_bg3.f40d96c2.png";